($ => {
  Drupal.behaviors.footer = {
    attach(context) {
      $('.footer_menu--items .menu-item--expanded > a', context).click(e => {
        const parentElement = e.currentTarget.closest('.menu-item');
        const $subMenu = $().add(parentElement.querySelector('.menu'));
        e.currentTarget.classList.toggle('open-menu');
        if ($(window).innerWidth() < 900) {
          if ($subMenu.hasClass('open')) {
            $subMenu.removeClass('open');
            $subMenu.slideUp(250);
          } else {
            $subMenu.addClass('open');
            $subMenu.slideDown(250);
          }
        }
      });
    },
  };
})(jQuery);
